import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { RouterModule } from '@angular/router';
import { CountdownComponent } from './countdown.component';

@NgModule({
  declarations: [
    CountdownComponent
  ],
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule,
    RouterModule
  ],
  exports: [
    CountdownComponent
  ],
})
export class CountdownModule { }
